/* Stolen from småjobber (thanks), and slightly modified to be a module */
export default function(options, callback) {
    const noop = { abort() {} };
    const fps = options.fps || 24;
    const duration = options.duration || 500;
    const diff = options.end - options.start;
    let steps = fps * (duration / 1000);
    let stepSize = diff / steps;
    let count = options.start;
    let timer;

    if (typeof options.start !== 'number') {
        callback(options.end);
        return noop;
    }

    if (typeof options.end !== 'number') {
        callback(options.start);
        return noop;
    }

    if (options.start === options.end) {
        callback(options.start);
        return noop;
    }

    if (Math.abs(stepSize) < 1) {
        stepSize = diff < 0 ? -1 : 1;
    }
    const countDown = function() {
        count += stepSize;
        steps--;
        callback(Math.round(count));
        if (Math.round(count) === options.end) {
            return;
        }
        if (steps === 0) {
            callback(options.end);
        } else {
            timer = setTimeout(countDown, 1000 / fps);
        }
    };

    timer = setTimeout(countDown, 1000 / fps);
    return {
        abort() {
            clearTimeout(timer);
        },
    };
}



// WEBPACK FOOTER //
// ./lib/counter.js